import "./SorterNav.scss";
import { useState } from "react";

const SorterNav = ({ items, onSelect }) => {
  const [activeOption, setActiveOption] = useState("");
  // const [selectValue, setSelectValue] = useState("");

  const handleItemClick = (option, callback) => {
    setActiveOption(option);
    callback();
  };

  //درست کار نمیکنه چون کل دیتا باید از بک بیاد با یه ریکوست
  // const changeHandler = (e) => {
  //   debugger;
  //   setSelectValue(e.target.value);
  //   items.forEach((v) => {
  //     if (v.title === e.target.value) {
  //       v.onClick();
  //     }
  //   });
  // };

  return (
    <div>
      <div className="navCategoris_">
        <span>مرتب سازی براساس :</span>
        <ul className="sorterList__">
          {items.map((v, index) => {
            return (
              <li
                className={`liSorter_ ${
                  activeOption === v.title ? "tabs_active" : ""
                } `}
                key={index + "sortNav"}
                onClick={() => onSelect("sort", v.id)}
                id={v?.id}
              >
                {v?.title}
              </li>
            );
          })}
        </ul>
      </div>
      {/* <div className="responsive_sortNav">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
            fill="#778D50"
          />
          <path
            d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
            fill="#778D50"
          />
          <path
            d="M14 17.75H10C9.59 17.75 9.25 17.41 9.25 17C9.25 16.59 9.59 16.25 10 16.25H14C14.41 16.25 14.75 16.59 14.75 17C14.75 17.41 14.41 17.75 14 17.75Z"
            fill="#778D50"
          />
        </svg>

        <select onChange={changeHandler} defaultValue={selectValue}>
          {items.map((v, index) => {
            return (
              <option key={index} value={v.title}>
                {v.title}
              </option>
            );
          })}
        </select>
      </div> */}
    </div>
  );
};

export default SorterNav;
